module.exports = __webpack_public_path__ + "img/arrow-blue-open.8e144221.svg";